import styles from './search_filters_separator.module.css';

const SearchFiltersSeparator = () => <div className={styles.separator} />;

export default SearchFiltersSeparator;
